(ns teamoesterreich.user-mode.profile.profile-setup
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]

    ))




(defn get-it []
  (let [!profile-state (r/cursor store/app-state [:profile-state])
        !actual-user (r/cursor store/app-state [:actual-user])]
    (a/set-bottom-action-fn #(swap! !profile-state assoc :profile-page nil :personal-form {}))

    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"
                          }}

       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Einstellungen"]
         [:span
          "Platzhalter ... "]

         ]



        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :style     {:margin "10px 0 10px 10px" :width "200px"}
           :onClick   #(a/set-page-back)
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]

         ]

        ]]]]
    ))